// extracted by mini-css-extract-plugin
export default {"PageVerification":"PageVerification_PageVerification__0Txuw","PartieDroite":"PageVerification_PartieDroite__pWoFn","Formulaire":"PageVerification_Formulaire__boD4Q"};